<template>
	<div class="listClass">
		<!-- banner不一样的一级不一样的banner，圣地峨眉，玩转峨眉，旅游攻略这种一级页面跳转列表一个图片 -->
		<div class="banner">
			<cms-image
					:src="pathList=='/link'?linkImg:pathList=='/plan'?planImg:pathList=='/service'?seviceImg:pathList=='/visitor'?visitorImg:defultImg"></cms-image>
			<PageNavigater></PageNavigater>
		</div>
		<div class="contain">
			<div class="content">
				<div class="title-bg"></div>
				<!-- 注意picture不与其他共用 -->
				<template v-if="type === 'picture'">
					<div class="bg">
						<div class="title">{{ pageTitle }}</div>
						<div class="__change"><router-link to="/link/pictureList">切换为列表查看</router-link></div>
						<div class="data-list">
							<div class="picture-item">
								<div class="info">
									<div class="info-content">
										<div class="info-waring">使用须知</div>
										<div class="info-text">以下所有图片版权归属于峨眉山旅游股份有限公司，下载图片仅限用于峨眉山宣传或收藏，不可用于任何商业行为。
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="img-list">
							<div class="thumb-example">
								<!-- swiper1 -->
								<swiper v-if="isReady" class="swiper gallery-top" @slideChange="onSlideChange"
										:options="swiperOptionTop" ref="swiperTop">
									<swiper-slide v-for="(item, index) in pictureList" :key="'picture1'+index"
												  :style="'background-image:url('+item.src+')'">
										<!-- <img :data-src="item.src" alt="" class="cms-image" v-if="index > 0">
										<img :src="item.src" alt="" class="cms-image" v-else>
										<div class="preloader-container" v-if="index > 0">
											<div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
										</div> -->
									</swiper-slide>
								</swiper>
								<div class="author">
									<div class="text">
										<span>作品名称：</span>
										{{ pictureInfo.name }}
									</div>
									<div class="text">
										<span>地点：</span>
										{{ pictureInfo.address }}
									</div>
									<div class="text">
										<span>拍摄者：</span>
										{{ pictureInfo.photographer }}
									</div>
									<div class="rightBtn">
										<div>
											<a @click="viewPicture">查看原图</a>
										</div>
										<div v-if="pictureList[pictureIndex]">
											<a target="_blank" :href="pictureList[pictureIndex].src.replace('_thin', '')" download="download">下载原图</a>
										</div>
									</div>
								</div>
								<!-- swiper2 Thumbs -->
								<swiper v-if="isReady" class="swiper gallery-thumbs" :options="swiperOptionThumbs"
										ref="swiperThumbs">
									<swiper-slide v-for="(item, index) in pictureList" :key="'picture2'+index"
												  :style="'background-image:url('+item.src+')'">
										<!--<cms-image :src="item.src"></cms-image>-->
										<!-- <img :data-src="item.src" class="swiper-lazy"> -->
										<!-- <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div> -->
									</swiper-slide>
									<div class="swiper-button-next swiper-button-white" slot="button-next">
										<div class="btn"></div>
									</div>
									<div class="swiper-button-prev swiper-button-white" slot="button-prev">
										<div class="btn"></div>
									</div>
								</swiper>
							</div>
						</div>
					</div>
				</template>

				<!-- 其余用这的样式 -->
				<div class="bg" v-else>
					<div class="title">{{ pageTitle }}</div>
					<!-- tab做个参数可有可无 ，超过4个，class加个more -->
					<div class="tab" :class="{ more: tabList.length > 4 }" v-if="tabList.length > 0 &&  isShowTab">
						<div class="tab-item" :class="{ active: activeTabIndex === index }"
							 v-for="(item, index) in tabList" :key="index" @click="tab(index)">{{ item.name }}
						</div>
					</div>

					<!-- subImg做个参数 玩转峨眉-玩得安逸-子页面的插图-->
					<div class="sub-img" v-if="subImg && tabList.length > 0">
						<div class="left-img" :class="'left-img'+activeTabCode" v-if="activeTabCode === 'tswq'">
							<swiper class="swiperWq" ref="swiperWq" :options="swiperOptionWq">
								<swiper-slide class="pointer">
									<cms-image :src="require('~/views/img/list/subImg/wenquan_hz.png')"></cms-image>
								</swiper-slide>
								<swiper-slide class="pointer">
									<cms-image :src="require('~/views/img/list/subImg/wenquan_yj.png')"></cms-image>
								</swiper-slide>
								<swiper-slide class="pointer">
									<cms-image :src="require('~/views/img/list/subImg/wenquan_lx.png')"></cms-image>
								</swiper-slide>
							</swiper>
						</div>
						<div class="left-img" :class="'left-img'+activeTabCode" v-else>
						</div>
						<div class="right-text">
							<div class="right-top-img" :class="'right-top-img' + activeTabCode"></div>
							<div class="right-note">{{ tabList[activeTabIndex].note }}</div>
						</div>
					</div>

					<!-- buySubImg做个参数 玩转峨眉-购得开心-子页面的插图-->
					<div class="buy-sub-img" v-if="buySubImg">
						<div class="top-img" v-if="activeTabCode === 'emxy'">
							<cms-image :src="require('~/assets/img/buy-sub-img.png')" radius></cms-image>
							<div class="net" style="cursor: pointer">
								<cms-image :src="require('~/assets/img/net.png')" @click="$openNewWindow('http://www.beatea.com/product.html')"></cms-image>
							</div>
						</div>
						<div class="top-img" v-if="activeTabCode === 'emwc'">
							<cms-image :src="require('~/assets/img/buy-sub-img2.png')"></cms-image>
							<div class="net">
								<cms-image :src="require('~/assets/img/net2.png')"></cms-image>
							</div>
						</div>
						<cms-article-list :pid="articlePid" :query="{ext1: '精品文章'}" class="buy-swiper">
							<template slot-scope="{list}">
								<swiper class="swiper" ref="swiper" :options="swiperOption">
									<swiper-slide v-for="item in list" :key="item.id" class="pointer">
										<cms-image :src="item.cover" radius animate="scale"
												   @click="itemClick(item)"></cms-image>
										<div class="mask">{{ item.title }}</div>
									</swiper-slide>
									<swiper-slide v-if="list.length === 0">
										<cms-image :src="require('~/components/img/defultImg.png')" radius></cms-image>
										<div class="mask">暂无精品推荐</div>
									</swiper-slide>
								</swiper>
								<div class="swiper-button-prev-normal" slot="button-prev" v-if="list.length > 3" @click="prev">
									<div class="btn"></div>
								</div>
								<div class="swiper-button-next-normal" slot="button-next" v-if="list.length > 3" @click="next">
									<div class="btn"></div>
								</div>
							</template>
						</cms-article-list>
					</div>

					<!-- 玩的安逸-温泉欢乐谷独有的一项 -->
					<div class="wenqun-item" v-if="wenqunItem && activeTabCode === 'wqhlg'">
						<cms-article-list :pid="articlePid" :limit="3" :query="{ext1: '置顶文章'}"
										  class="wenqun-first-item">
							<template slot-scope="{list}">
								<div class="wenqun-first-item-1" v-for="item in list" :key="item.id"
									 @click="itemClick(item)">
									<div class="imgCover">
										<cms-image :src="item.cover"></cms-image>
										<div class="mask"></div>
									</div>
									<div class="img-text">{{ item.title }}</div>
								</div>
							</template>
						</cms-article-list>
						<div class="wenqun-second-title">峨眉山温泉特色项目</div>
						<div class="wenqun-second-item">
							<div class="wenqun-second-item-item">
								<div class="wenqun-second-content">
									<div class="wenqun-second-img wenqun-second-img1">
										<!-- <cms-image :src="secondImage1"></cms-image> -->
										<div class="second-img-title">氡水</div>
										<div class="second-img-text">
											来自地下3000米的深处富含多种有利于人体健康的微量元素和矿物质，是治疗神经、消化、心血管系统疾病的良方。
										</div>
									</div>
								</div>
							</div>
							<div class="wenqun-second-item-item">
								<div class="wenqun-second-content">
									<div class="wenqun-second-img wenqun-second-img2">
										<!-- <cms-image :src="secondImage2"></cms-image> -->
										<div class="second-img-title">硫温泉</div>
										<div class="second-img-text">源于峨眉山下2000多米的地心深处，具有5000多年的矿化龄。</div>
									</div>
								</div>
							</div>
							<div class="wenqun-second-item-item">
								<div class="wenqun-second-content">
									<div class="wenqun-second-img  wenqun-second-img3">
										<!-- <cms-image :src="secondImage3"></cms-image> -->
										<div class="second-img-title">零度温泉</div>
										<div class="second-img-text">感受冰透劲爽的零度温泉把清凉留在肌肤之间。</div>
									</div>
								</div>
							</div>
							<div class="wenqun-second-item-item">
								<div class="wenqun-second-content">
									<div class="wenqun-second-img  wenqun-second-img4">
										<!-- <cms-image :src="secondImage4"></cms-image> -->
										<div class="second-img-title">温泉SPA</div>
										<div class="second-img-text">
											中国首家森林温泉SPA，在纯新的空气和静谧的环境中，以畅快的感官之旅呼唤生命能量，达到最完美和谐的境界。
										</div>
									</div>
								</div>
							</div>
							<div class="wenqun-second-item-item">
								<div class="wenqun-second-content">
									<div class="wenqun-second-img wenqun-second-img5">
										<!-- <cms-image :src="secondImage5"></cms-image> -->
										<div class="second-img-title">温泉鱼疗</div>
										<div class="second-img-text">和鱼儿们亲亲啃啃，亲密接触。</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<cms-article-list :pid="articlePid" :limit="pageSize" :query="{ext1Empty: ext1Empty}"
									  :page="currentPage" :sort-by="sortBy" class="data-list" @loaded="articleLoaded">
						<template slot-scope="{ list }">
							<!-- list-title做个参数 -->
							<div class="list-title" v-if="listTitle">相关文章</div>
							<!-- 图片用img-item，文章用data-item -->
							<template v-if="type === 'video'">
								<div class="img-item" v-for="item in list" :key="item.id" @click="itemClick(item)">
									<div class="bgImg">
										<cms-image :src="item.cover"></cms-image>
										<div class="mask" v-if="videoMask"></div>
									</div>
									<div class="img-item-title">{{ item.title }}</div>
								</div>
							</template>

							<!--普通文章列表-->
							<template v-if="type === 'article'">
								<div class="data-item" :class="isIE ? 'classie' : ''" v-for="item in list" :key="item.id" @click="itemClick(item)" style="cursor: pointer">
									<div class="img">
										<cms-image :src="item.cover"></cms-image>
									</div>
									<div class="rightContent">
										<div class="artile-title" :class="{ hasstar: item.star }">
											{{ item.title }}
										</div>
										<div class="tag" v-if="item.ext1 && tag">{{ item.ext1 }}</div>
										<div class="artile-content">
											{{ item.intro }}
										</div>
										<div class="artile-detail"><a>查看详情</a></div>
										<div class="rate strategy_rate" v-if="item.star">
											<span>推荐指数：</span>
											<el-rate v-model="item.star" :disabled="true"></el-rate>
										</div>
									</div>
								</div>
								<div class="no-content" v-if="list.length === 0">暂无内容</div>
							</template>

							<!--精彩体验列表-->
							<template v-if="type === 'experience'">
								<!-- 当长度大于6的时候，加上experience-more，不然第5、6两个模块样式不一样 -->
								<div class="experience-outFlex " :class="list.length>6?'experience-more':''">
									<div class="experience-item" v-for="(item, index) in list" :key="item.id"
										 @click="itemClick(item)">
										<div class="bgImg">
											<cms-image :src="item.cover"></cms-image>
											<div class="mask">
												{{ index + 1 }}
											</div>
											<div class="experience-item-intro">
												<div class="experience-item-intro-title">{{ item.title }}</div>
												<div class="experience-item-intro-text">
													{{ item.intro }}
												</div>
												<div class="experience-item-intro-more">更多>></div>
											</div>
										</div>
									</div>
									<cms-column :id="articlePid" class="intro">
										<template slot-scope="{ data }">
											<cms-image :src="enjoy[data.id]"></cms-image>
											<div class="text">{{ data.note }}</div>
										</template>
									</cms-column>
								</div>
							</template>
						</template>
					</cms-article-list>

					<!-- 底下分页器做个参数，可有可无 -->
					<div class="page" v-if="pageNav">
						<el-pagination background layout="prev, pager, next" ref="pagination" :page-size="pageSize" :total="total" :current-page="listPage"
									   @current-change="pageChange">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import '~/views/less/list.css'
	import Logo from '~/components/Logo'
	import Page from '~/components/Page'
	import ZuiHeader from '~/components/Header'
	import ZuiFooter from '~/components/Footer'
	import ZuiButton from '~/components/Button'
	import {
		swiper,
		swiperSlide
	} from 'vue-awesome-swiper';
	import 'swiper/css/swiper.css';
	import {
		getColumns,
		getArticle,
		getArticles
	} from "~/api/CmsApi";

	export default {
		components: {
			Page,
			Logo,
			ZuiHeader,
			ZuiFooter,
			ZuiButton,
			swiper,
			swiperSlide
		},
		props: {
			tag: { //两日游标签
				type: Boolean,
				default: false
			},
			// 是否加载tab（从服务器获取）
			dynamicallyTab: {
				type: Boolean,
				default: false
			},
			// 静态tab栏（不需要接口加载的）
			staticTabList: {
				type: Array,
				default: () => []
			},
			// 默认选中的tab id
			defaultTabId: {
				type: String,
				default: ''
			},
			// 玩得安逸子页面带的图片简介
			subImg: {
				type: Boolean,
				default: false
			},
			// 玩的安逸-温泉欢乐谷独有的一项
			wenqunItem: {
				type: Boolean,
				default: false
			},
			// 购得开心子页面的插图
			buySubImg: {
				type: Boolean,
				default: false
			},
			// 列表标题，如果tab和list中间有图片，就展示列表标题
			listTitle: {
				type: Boolean,
				default: false
			},
			// 页码是否展示
			pageNav: {
				type: Boolean,
				default: true
			},
			// picture图库，video视频，article文章，experience精彩体验
			type: {
				type: String,
				default: ''
			},
			videoMask: {
				type: Boolean,
				default: true
			},
			// 当前页面一页加载条数，文章默认4条或6条，图片一页加载6条
			pageSize: {
				type: Number,
				default: 4
			},
			// 页面标题
			pageTitle: {
				type: String,
				default: ''
			},
			// 父栏目id
			pid: {
				type: String,
				default: ''
			},
			/**
			 * 这个参数通常是true，他的作用是，当一个文章列表页，上方展示精品文章，下方的相关文章列表中就要不展示精品推荐内容。此时按照ext1为空过滤
			 * 详细用法参考-玩转峨眉-购得开心
			 */
			ext1Empty: {
				type: Boolean,
				default: true
			},
			/**
			 * 排序方式 0:时间倒序 1:sort值正序 2:ext1倒序（此时ext1为日期）
			 */
			sortBy: {
				type: [String, Number],
				default: ''
			},
			currentPage: {
				type: Number,
				default: 1
			},
			isShowTab: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				isReady: false,
				defultImg: require('~/views/img/list/link-banner.jpg'),
				linkImg: require('~/views/img/list/link-banner.jpg'),
				planImg: require('~/views/img/list/plan-banner.jpg'),
				seviceImg: require('~/views/img/list/sevice-banner.jpg'),
				visitorImg: require('~/views/img/list/visitor-banner.jpg'),
				tabList: [],
				pathList: [],
				swiperOption: {
					slidesPerView: 3,
					spaceBetween: 30,
					lazy: true,
					navigation: {
						nextEl: '.swiper-button-next-normal',
						prevEl: '.swiper-button-prev-normal'
					},
				},
				swiperOptionWq: {
					slidesPerView: 1,
					spaceBetween: 0,
					lazy: true,
					autoplay:true,
				},
				swiperOptionTop: {
					loop: true,
					loopedSlides: 7, // looped slides should be the same
					spaceBetween: 10
				},
				swiperOptionThumbs: {
					loop: true,
					lazy: true,
					loopedSlides: 7, // looped slides should be the same
					spaceBetween: 10,
					centeredSlides: true,
					slidesPerView: 'auto',
					touchRatio: 0.2,
					slideToClickedSlide: true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				},
				enjoy: {
					'39': require('~/views/img/list/enjoy/39.jpg'),
					'40': require('~/views/img/list/enjoy/40.jpg'),
					'41': require('~/views/img/list/enjoy/41.jpg'),
					'42': require('~/views/img/list/enjoy/42.jpg'),
					'43': require('~/views/img/list/enjoy/43.jpg'),
				},
				// 温泉特色项目
				springFeatures: [],
				activeTabIndex: 0,
				// currentPage: 1,
				articlePid: null,
				total: 0,
				pictureIndex: 0,
				pictureList: [],
				pictureCurrentPage: 0,
				listPage: 1,
				isIE: false
			}
		},
		mounted() {
      console.log(this.pid)
			var SubPageColumn = localStorage.getItem('SubPageColumn');
			var page = 0;
			localStorage.setItem('SubPageColumn', '');
            console.log(SubPageColumn )
			if (SubPageColumn != '') {
				var column = JSON.parse(SubPageColumn);
				if (column && column.path === window.location.pathname) {
					if (column.tab && column.path != "/new/plan/delicious"){
						this.defaultTabId = column.tab;
          }
					if (column.page)
						page = column.page;
				}
			}
			this.currentPage = page || Number(this.$route.query.page) || 1;
			this.pathList = this.getPathList();
			if (this.type === 'picture') {
            console.log('this.type === picture')
				this.pictureIndex = 0;
				this.pictureList = [];
				this.getPicturesFromArticle();
			}
			if (this.staticTabList.length > 0) {
        console.log('this.staticTabList.length > 0')

				this.tabList = [...this.staticTabList];
				if (this.defaultTabId) {
					const defaultTabIndex = this.tabList.findIndex(a => a.id == this.defaultTabId);
					this.activeTabIndex = defaultTabIndex === -1 ? 0 : defaultTabIndex;
					this.articlePid = this.tabList[this.activeTabIndex].id;
				}
			} else if (this.dynamicallyTab) {
				this.getTabs();
			} else if (this.pid) {
        console.log('his.pid')
				this.articlePid = this.pid;
			}
			document.body.scrollTop = document.documentElement.scrollTop = 0;
			if (document.documentMode)
				this.isIE = true;
		},
		computed: {
			activeTabCode() {
				if (this.tabList[this.activeTabIndex]) {
					return this.tabList[this.activeTabIndex].code;
				}
				return '';
			},
			pictureInfo() {
				return this.pictureList[this.pictureIndex] || {
					src: '',
					name: '',
					address: '',
					photographer: ''
				}
			}
		},
		methods: {
			prev(){
				this.$refs.swiper.swiper.slidePrev()
			},
			next(){
				this.$refs.swiper.swiper.slideNext()
			},
			getPathList() {
				if (this.$route.path === '') {
					return []
				}
				const route = this.$router.getRoutes().find(a => a.path === this.$route.path);
				const pathList = [];
				const putTogether = data => {
					pathList.unshift({
						path: data.path,
						meta: data.meta
					});
					if (data.parent && data.parent.path !== '/home') {
						putTogether(data.parent);
					}
				}
				putTogether(route);
				pathList.unshift({
					path: '/home',
					meta: {
						title: '首页'
					}
				});
				return pathList[1].path;
			},
			tab(index) {
				this.activeTabIndex = index;
				this.articlePid = this.tabList[index].id;
				this.currentPage = 1;
				this.$emit('tab-change', index);
			},
			getTabIndex() {
				return this.activeTabIndex;
			},
			getTabs() {
				const param = {
					page: 1,
					limit: 99,
					pid: this.pid
				};
				getColumns(param).then(res => {
					if (res.code === 0) {
						const list = res.data.records || [];
						if (this.sortBy === 'sort') {
							list.sort((a, b) => a.sort - b.sort);
						}
						this.tabList = list;

						this.$nextTick(() => {
							if (this.$route.query.defTabId) {
                console.log(22)
								this.articlePid = this.$route.query.defTabId;
								const defaultTabIndex = this.tabList.findIndex(a => a.id == this.articlePid);
								this.activeTabIndex = defaultTabIndex === -1 ? 0 : defaultTabIndex;
							} else if (this.defaultTabId) {
                console.log(33)
								const defaultTabIndex = this.tabList.findIndex(a => a.id == this.defaultTabId);
								this.activeTabIndex = defaultTabIndex === -1 ? 0 : defaultTabIndex;
								this.articlePid = this.tabList[this.activeTabIndex].id;
							} else {
                console.log(44)
								this.articlePid = this.isShowTab ? this.tabList[0].id : this.pid;

							}

							// 新增点击按照点击事件进行首次显示
							if (this.$route.query.tabIndex>-1) {
								const defaultTabIndex =Number(this.$route.query.tabIndex) ;
								this.activeTabIndex = defaultTabIndex === -1 ? 0 : defaultTabIndex;
								this.articlePid = this.tabList[this.activeTabIndex].id;

								console.log(11)
							}
						});
					} else {
						console.warn('栏目信息获取失败');
					}
				})
			},

			articleLoaded(list, total) {
				this.total = total;
				this.listPage = this.currentPage;
			},
			pageChange(page) {
				// const base = this.$router.options.base;
				// let path = this.$route.path;
				// if (base) {
				//   path = base + path.substring(1);
				// }
				//
				// const query = this.$route.query || {};
				// query.page = page;
				// let str = '';
				// for (const key in query) {
				//   str += `&${key}=${query[key]}`;
				// }
				// str = str.substring(1);
				//
				// this.$router.push({
				//   path: `${path}?${str}`
				// })
				this.currentPage = page;
			},
			itemClick(item) {
				if (this.tabList.length > 0 && this.tabList[this.activeTabIndex]) {
					localStorage.setItem('article_pid', this.articlePid);
					localStorage.setItem('article_pname', this.tabList[this.activeTabIndex].name);
				}
				localStorage.setItem('SubPageColumn', JSON.stringify({path: window.location.pathname, tab: this.articlePid, page: this.currentPage}));
				this.$emit('article-click', item);
			},
			getPicturesFromArticle() {
				const param = {
					cateId: this.$cid.picture,
					sortBy: 1,
					page: ++this.pictureCurrentPage,
					limit: 100
				}
				getArticles(param).then(res => {
					if (res.code === 0) {
						const list = res.data.records || [];
						list.forEach(item => {
							this.pictureList.push({
								src: item.cover,
								name: item.title,
								address: item.ext1,
								photographer: item.ext2 || '--'
							});
						});
						this.isReady = true;
						this.$nextTick(() => {
							const swiperTop = this.$refs.swiperTop.swiper
							const swiperThumbs = this.$refs.swiperThumbs.swiper
							setTimeout(function () {
								swiperTop.controller.control = swiperThumbs
								swiperThumbs.controller.control = swiperTop
							}, 5000);
						})
					}
				})
			},
			onSlideChange() {
				this.pictureIndex = this.$refs.swiperTop.swiper.realIndex;
				if (this.pictureIndex === this.pictureList.length - 1) {
					this.getPicturesFromArticle();
				}

				/**
				 * 图片懒加载
				 * @type {HTMLCollectionOf<Element>}
				 */
				const activeElements = this.$refs.swiperTop.$el.getElementsByClassName('swiper-slide-next');
				if (activeElements && activeElements.length > 0) {
					// 切换到当前图片时，将data-src赋值到src上
					const imgs = activeElements[0].getElementsByTagName('img');
					if (imgs && imgs.length > 0) {
						imgs[0].setAttribute('src', imgs[0].getAttribute('data-src'));
					}
					// 切换到当前图片时，移除loading
					const preloaderELem = activeElements[0].getElementsByClassName('preloader-container');
					if (preloaderELem && preloaderELem.length > 0) {
						preloaderELem[0].remove();
					}
				}
			},
			viewPicture() {
				const image = this.pictureList[this.pictureIndex].src;
				this.$viewerApi({
					images: [image],
				})
			},
			loadSpringFeatures() {
				this.springFeatures.push({})
			}
		}
	}
</script>
<style  scoped>

</style>

</style>



// WEBPACK FOOTER //
// src/components/template/SubPageTemplate.vue